import axios from "./index.service";

export default class MetricsService {
  static getSystemMetrics() {
    return axios({
      method: "GET",
      url: "/api/services/v1/metrics/",
    });
  }

  static getTransactionMetrics() {
    return axios({
      method: "GET",
      url: "/api/services/v1/metrics/transaction",
    });
  }
}
